export const EXPERIMENTS = {
    EMAIL_VALIDATION: 'ab_test_email_validation',
    FRESH_CHAT: 'fresh-chat',
};
export const EXPERIMENTS_TO_USER_PROPS_MAP = {
    [EXPERIMENTS.EMAIL_VALIDATION]: 'ab_test_email_validation',
};
export var EXPERIMENTS_ENUM;
(function (EXPERIMENTS_ENUM) {
    EXPERIMENTS_ENUM["EMAIL_VALIDATION"] = "ab_test_email_validation";
    EXPERIMENTS_ENUM["FRESH_CHAT"] = "fresh-chat";
})(EXPERIMENTS_ENUM || (EXPERIMENTS_ENUM = {}));
export var EXPERIMENTS_TO_USER_PROPS_MAP_ENUM;
(function (EXPERIMENTS_TO_USER_PROPS_MAP_ENUM) {
    EXPERIMENTS_TO_USER_PROPS_MAP_ENUM["EMAIL_VALIDATION"] = "ab_test_email_validation";
})(EXPERIMENTS_TO_USER_PROPS_MAP_ENUM || (EXPERIMENTS_TO_USER_PROPS_MAP_ENUM = {}));
